import React, { useMemo } from 'react';
import { Button, Flex, Form, Input, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { general, generalFields } from 'shared/model/schemas/rules';

const Pin: React.FC<{ onSubmit: (data: { '3ds': string }) => unknown }> = ({
  onSubmit,
}) => {
  const { formatMessage: t } = useIntl();
  const [form] = Form.useForm();
  const passwordValue = Form.useWatch('3ds', form);
  const passwordError = form.getFieldError('3ds');

  const isButtonDisabled = !passwordValue || passwordError.length > 0;

  const rules = useMemo(() => [
    general(t)['required-field'],
    ...generalFields(t)['3ds']
  ], [t]);

  return (
    <Form form={form} onFinish={onSubmit} layout="vertical" style={{ flex: 1, padding: '24px 0' }}>
      <Flex vertical justify="space-between" style={{ flex: 1, minHeight: 200 }}>
        <div>
          <Typography.Text style={{ marginBottom: 16, display: 'block', whiteSpace: 'pre-line' }}>
            {t({ id: 'labels.3ds' })}
          </Typography.Text>
          <Form.Item
            name="3ds"
            rules={rules}>
            <Input.Password placeholder={t({ id: 'inputs.password.password' })} />
          </Form.Item>
        </div>
        <Button
          style={{ marginTop: 40 }}
          disabled={isButtonDisabled}
          htmlType="submit"
          type="primary"
          block>
          {t({ id: 'card.getPlastic.button.order' })}
        </Button>
      </Flex>
    </Form>
  );
};

export default Pin;
